<p-dialog
    id="add-new-informed-user-modal"
    class="custom-modal"
    [draggable]="false"
    [visible]="true"
    [modal]="true"
    [closable]="false"
    [resizable]="false">
    <ng-template pTemplate="header">
        <div class="modal-header">
            <h3 class="modal-title">{{ 'orders.setup.orderSummary.addUserToInform' | translate }}</h3>
            <button
                id="add-new-informed-user-modal-close-btn"
                autofocus
                pButton
                type="button"
                icon="pi pi-times"
                class="p-button-rounded p-button-secondary p-button-text"
                (click)="closeModal()"></button>
        </div>
    </ng-template>
    <div class="content">
        @if (isAddingNewInformedUser) {
            <app-loader [overlay]="true"></app-loader>
        }

        <p class="info">{{ 'orders.setup.orderSummary.addUserToInformModal.info' | translate }}</p>

        <form [formGroup]="newInformedUserForm" class="content">
            <!-- First Name -->
            <div class="field">
                <label
                    id="add-new-informed-user-first-name-label"
                    for="add-new-informed-user-first-name-input"
                    [class.error-text]="firstName.touched && firstName.invalid"
                    >{{ 'orders.setup.orderSummary.addUserToInformModal.firstName' | translate }}
                    <span class="p-error">*</span></label
                >
                <input
                    id="add-new-informed-user-first-name-input"
                    type="text"
                    pInputText
                    formControlName="firstName"
                    [placeholder]="'orders.setup.orderSummary.addUserToInformModal.firstNamePlaceholder' | translate"
                    [class.border-error]="firstName.touched && firstName.invalid"
                    [class.ng-invalid]="firstName.touched && firstName.invalid" />
                <div class="validators-container">
                    <app-validation-error
                        [fieldId]="'add-new-informed-user-first-name'"
                        [customFormControl]="firstName"
                        [formEntity]="validatorFormEntities.ADD_NEW_INFORMED_USER_FIRST_NAME">
                    </app-validation-error>
                </div>
            </div>

            <!-- Last Name -->
            <div class="field">
                <label
                    id="add-new-informed-user-last-name-label"
                    for="add-new-informed-user-last-name-input"
                    [class.error-text]="lastName.touched && lastName.invalid"
                    >{{ 'orders.setup.orderSummary.addUserToInformModal.lastName' | translate }}
                    <span class="p-error">*</span></label
                >
                <input
                    id="add-new-informed-user-last-name-input"
                    type="text"
                    formControlName="lastName"
                    pInputText
                    [placeholder]="'orders.setup.orderSummary.addUserToInformModal.lastNamePlaceholder' | translate"
                    [class.border-error]="lastName.touched && lastName.invalid"
                    [class.ng-invalid]="lastName.touched && lastName.invalid" />
                <div class="validators-container">
                    <app-validation-error
                        [fieldId]="'add-new-informed-user-last-name'"
                        [customFormControl]="lastName"
                        [formEntity]="validatorFormEntities.ADD_NEW_INFORMED_USER_LAST_NAME">
                    </app-validation-error>
                </div>
            </div>

            <!-- Email Address -->
            <div class="field">
                <label
                    id="add-new-informed-user-email-label"
                    for="add-new-informed-user-email-input"
                    [class.error-text]="email.touched && email.invalid"
                    >{{ 'emailAddress' | translate }} <span class="p-error">*</span></label
                >
                <input
                    id="add-new-informed-user-email-input"
                    type="text"
                    formControlName="email"
                    pInputText
                    [placeholder]="'orders.setup.orderSummary.addUserToInformModal.emailAddressPlaceholder' | translate"
                    [class.border-error]="email.touched && email.invalid"
                    [class.ng-invalid]="email.touched && email.invalid" />

                <div class="validators-container">
                    <app-validation-error
                        [fieldId]="'add-new-informed-email'"
                        [customFormControl]="email"
                        [formEntity]="validatorFormEntities.ADD_NEW_INFORMED_USER_EMAIL">
                    </app-validation-error>
                </div>
            </div>
        </form>

        <p-divider></p-divider>
    </div>

    <ng-template pTemplate="footer">
        <div class="action-buttons-container">
            <p-button
                id="add-new-informed-user-cancel-btn"
                [outlined]="true"
                [severity]="'secondary'"
                [disabled]="isAddingNewInformedUser"
                (click)="closeModal()">
                {{ 'cancel' | translate }}
            </p-button>

            <p-button
                id="add-new-informed-user-save-btn"
                [disabled]="isAddingNewInformedUser"
                [severity]="'success'"
                (click)="onSave()">
                {{ 'save' | translate }}
            </p-button>
        </div>
    </ng-template>
</p-dialog>
